import Api from "~/service/Api";

class Immersive3dTourProjectRepository {
  fetchOne(tourId) {
    return Api.get(`/immersive-3d-tour/projects/${tourId}`);
  }
}

export default Immersive3dTourProjectRepository;
